@switch (true) {
  @case (!!currency) {<span [innerHTML]="currency.symbol"></span>}
  @case (!!currencyCode) {<span>{{ currencyCode }}</span>}
}
<span><ng-content></ng-content></span>
